<template>
  <data-loader>
    <div class="sim-start-container">
      <div class="sim-start-content">
        <screen-size-warning></screen-size-warning>
        <div
          v-html="html"
        >
        </div>
        <div class="button-wrapper">
          <data-loader
            :check-route="true"
          >
            <button
              class="sim-start-button-primary"
              data-test="start-simulation-button"
              @click="startSimulation"
            >
              {{ isMultiSectionSimulation ? 'Start' : 'Continue' }}
            </button>
          </data-loader>
        </div>
      </div>
    </div>
  </data-loader>
</template>

<script>
import ScreenSizeWarning from '@/components/sims/ScreenSizeWarning.vue';
import DataLoader from '@/components/sims/DataLoader.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';

export default {
  components: {
    ScreenSizeWarning,
    DataLoader,
  },
  mixins: [WuxSimulationsMixin],
  computed: {
    html() {
      if (this.isMultiSectionSimulation) {
        return this.simulation.introText || 'Intro text missing, configured on the category for this simulation.';
      } else if (this.isSimulation) {
        return this.simConfig?.startHtml || 'Intro text missing, configured in the simulation config for this category.';
      }
      return 'This category is not a simulation.';
    },
  },
  methods: {
    startSimulation() {
      if (this.isMultiSectionSimulation) {
        return this.startMultiSectionSimulation();
      } else if (this.isSimulation) {
        return this.startSingleSectionSimulation();
      }
      return this.$router.push({ name: 'home' });
    },
    startMultiSectionSimulation() {
      const childrenIds = this.simulation?.children || [];
      const sections = this.$store.getters['categories/all'].
        filter( c => childrenIds.includes(c.id) ).
        sort( (a, b) => a.number - b.number );

      const params = {
        number: 0,
        categoryStatusId: this.notStartedStatus.id,
        categoryStatusName: this.notStartedStatus.name,
        categoryId: sections[0].id,
        mobileCreatedAt: Date.now(),
      };
      this.$analytics.events.simulationCategoryState(params);
      this.$analytics.events.simulationStart({
        simulationId: this.simulation.id,
        simulationName: this.simulation.name,
      });
      return this.$store.dispatch('categoryStates/sendCategoryState', params).then(() => {
        return this.$router.push({
          name: 'simSection#show',
          params: {
            simId: this.simulation.id,
            sectionId: sections[0].id,
          },
        });
      });
    },
    startSingleSectionSimulation() {
      const params = {
        number: 0,
        categoryStatusId: this.notStartedStatus.id,
        categoryStatusName: this.notStartedStatus.name,
        categoryId: this.simulation.id,
        mobileCreatedAt: Date.now(),
      };

      this.$analytics.events.simulationCategoryState(params);
      return this.$store.dispatch('categoryStates/sendCategoryState', params).then(() => {
        return this.$router.push({
          name: 'sims#intro',
          params: {
            simId: this.simulation.id,
            pageNum: '1',
          },
        });
      });

    },
  },
};
</script>

<style lang="scss" scoped>
.sim-start-container {
  display: grid;
  place-items: center;
  height: 100%;
  background-color: #edf1f5;
}
.sim-start-content {
  max-width: 800px;
  display: inline-block;
  box-shadow: 0 0 10px 0 lightgray;
  padding: 2rem;
  border-radius: .5rem;
  background-color: white;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 2rem;

  .sim-start-button-primary {
    border-radius: 4px;
    box-sizing: border-box;
    color: white;
    font-size: rem-calc(18);
    font-weight: $semi-bold;
    margin-top: rem-calc(16);
    padding: rem-calc(6);
    text-align: center;
    width: rem-calc(150);
    height: rem-calc(46);
    background-color: #7bd56e;
    border: solid 1px #58AE4D;
  }
}
</style>>
